import { ItemType } from '@vista-digital/ocapi-types/v1';
import { isDiscountItemPrice, isMemberRewardItemPrice } from '../../../sales-data/utils/items/item-price-utils';
import { getAllowedOrderItemQuantityForRestrictedPrice } from './get-allowed-order-item-quantity-for-restricted-price';
import { getInProgressItem } from './get-in-progress-item';
export const getAllowedPriceRestrictedOrderItemQuantity = (allowedMaxForOrder, itemId, includeExistingOrderItemCount, // This property, when passed in as true, allows existing relevant order items to be added with allowed max if the UI requires an edit view
itemPrice) => {
    const inProgressItem = getInProgressItem();
    const inProgressItemPrice = (inProgressItem === null || inProgressItem === void 0 ? void 0 : inProgressItem.type) === ItemType.Normal ? inProgressItem.selectedPrice : undefined;
    const price = itemPrice || inProgressItemPrice;
    if (!price || !(isDiscountItemPrice(price) || isMemberRewardItemPrice(price)))
        return 0;
    const totalAvailableRestrictedPriceCount = getAllowedOrderItemQuantityForRestrictedPrice(price, itemId, includeExistingOrderItemCount);
    return Math.min(allowedMaxForOrder, totalAvailableRestrictedPriceCount);
};
